module.exports = __webpack_public_path__ + "static/10-0934976cb280725469a4c093c74bfe90.png";